module.exports = __webpack_public_path__ + "static/media/CreacionSucursal.3f0d3c91.png";